import React from 'react';
import PropTypes from 'prop-types';
import Message from '../message/Message';

const PlayerRank = ({gameModes}) => {
    if (!gameModes || !gameModes.length) return null;
    const renderGameMode = (gameMode) => {
        const {modeName, level, sublevel, numGamesPlayed, rating} = gameMode;
        return (
            <div className="rankRow" key={modeName}>
                <div className="statColumn"><Message code={`epic.ut.stats.mode_name_${modeName}`} />:</div>
                <div className="levelColumn">
                    <div className="skillRatingLevel">{sublevel}</div>
                    <div className={`levelClass level${level}`} />
                </div>
                <div className="rankColumn">
                    { numGamesPlayed < 10 ? <Message code="epic.ut.stats.less_game_played" /> : `(${rating})`}
                </div>
            </div>
        )
    }


    return (
        <div className="playerRank">
            {
                gameModes.map((gameMode) => {
                    return renderGameMode(gameMode);
                })
            }
        </div>
    )
}

PlayerRank.propTypes = {
    gameModes: PropTypes.arrayOf(PropTypes.shape())
}

export default PlayerRank
